'use strict';

var StampActionCreators = require('../actions/StampActionCreators'),
    FeedWithTrendingStore = require('../stores/FeedWithTrendingStore'),
    UserLatestStampStore = require('../stores/UserLatestStampStore'),
    UserLikedStampStore = require('../stores/UserLikedStampStore'),
    ZineLatestStampStore = require('../stores/ZineLatestStampStore'),
    ZinePendingStampStore = require('../stores/ZinePendingStampStore'),
    StampStore = require('../stores/StampStore'),
    ZineStore = require('../stores/ZineStore'),
    UserStore = require('../stores/UserStore'),
    BackColorMixin = require('../mixins/BackColorMixin'),
    createStoreMixin = require('../mixins/createStoreMixin');

var DEFAULT_COLORS = {
  background: 'efefef',
  text: 'dark'
};

module.exports = {
  Feed: {
    mixins: [createStoreMixin(FeedWithTrendingStore, StampStore, ZineStore)],

    requestPage: function (isInitialRequest) {
      StampActionCreators.requestFeedWithTrendingPage(isInitialRequest);
    },

    isExpectingPage() {
      return FeedWithTrendingStore.isExpectingPage();
    },

    isLastPage() {
      return FeedWithTrendingStore.isLastPage();
    },

    getPage: function () {
      return FeedWithTrendingStore.getStamps();
    },

    getStampPendingZine() {
      return null;
    },

    getStampPrimaryZine(stampId) {
      return StampStore.getPrimaryZine(stampId);
    },

    getNextUpTitle() {
      if (UserStore.isAuthenticated()) {
        return 'Next Up in Your Feed';
      } else {
        return 'Trending on Stampsy';
      }
    },

    shouldShowPrimaryZineInNextUp() {
      return true;
    },

    getColors() {
      return DEFAULT_COLORS;
    }
  },

  UserLatest: {
    mixins: [createStoreMixin(UserLatestStampStore, StampStore, UserStore)],

    getUserId: function () {
      return parseInt(this.props.params.userId, 10);
    },

    isExpectingPage() {
      var userId = this.getUserId();
      return UserLatestStampStore.isExpectingPage(userId);
    },

    isLastPage() {
      var userId = this.getUserId();
      return UserLatestStampStore.isLastPage(userId);
    },

    requestPage: function (isInitialRequest) {
      var userId = this.getUserId();
      StampActionCreators.requestUserLatestPage(userId, isInitialRequest);
    },

    getPage: function () {
      var userId = this.getUserId();
      return UserLatestStampStore.getStamps(userId);
    },

    getStampPendingZine() {
      return null;
    },

    getStampPrimaryZine(stampId) {
      return StampStore.getPrimaryZine(stampId);
    },

    getNextUpTitle() {
      var userId = this.getUserId(),
          user = UserStore.get(userId);

      if (user) {
        return `Also by ${user.name}`;
      }
    },

    shouldShowPrimaryZineInNextUp() {
      return true;
    },

    getColors() {
      return DEFAULT_COLORS;
    }
  },

  UserLiked: {
    mixins: [createStoreMixin(UserLikedStampStore, StampStore, UserStore)],

    getUserId: function () {
      return parseInt(this.props.params.userId, 10);
    },

    isExpectingPage() {
      var userId = this.getUserId();
      return UserLikedStampStore.isExpectingPage(userId);
    },

    isLastPage() {
      var userId = this.getUserId();
      return UserLikedStampStore.isLastPage(userId);
    },

    requestPage: function (isInitialRequest) {
      var userId = this.getUserId();
      StampActionCreators.requestUserLikedPage(userId, isInitialRequest);
    },

    getPage: function () {
      var userId = this.getUserId();
      return UserLikedStampStore.getStamps(userId);
    },

    getStampPrimaryZine(stampId) {
      return StampStore.getPrimaryZine(stampId);
    },

    getStampPendingZine() {
      return null;
    },

    getNextUpTitle() {
      var userId = this.getUserId(),
          user = UserStore.get(userId);

      if (user) {
        return `Also Liked by ${user.name}`;
      }
    },

    shouldShowPrimaryZineInNextUp() {
      return true;
    },

    getColors() {
      return DEFAULT_COLORS;
    }
  },

  ZineLatest: {
    mixins: [createStoreMixin(ZineLatestStampStore, ZineStore, StampStore), BackColorMixin],

    getZineSlug: function () {
      return this.props.params.zineSlug;
    },

    isExpectingPage() {
      var zineSlug = this.getZineSlug();
      return ZineLatestStampStore.isExpectingPage(zineSlug);
    },

    isLastPage() {
      var zineSlug = this.getZineSlug();
      return ZineLatestStampStore.isLastPage(zineSlug);
    },

    requestPage: function (isInitialRequest) {
      var zineSlug = this.getZineSlug();
      StampActionCreators.requestZineLatestPage(zineSlug, isInitialRequest);
    },

    getPage: function () {
      var zineSlug = this.getZineSlug();
      return ZineLatestStampStore.getStamps(zineSlug);
    },

    getStampPrimaryZine() {
      var zineSlug = this.getZineSlug();
      return ZineStore.get(zineSlug);
    },

    getStampPendingZine() {
      return null;
    },

    getNextUpTitle() {
      var zineSlug = this.getZineSlug(),
          zine = ZineStore.get(zineSlug);

      if (zine) {
        return `Next Up in ${zine.title}`;
      }
    },

    shouldShowPrimaryZineInNextUp() {
      return false;
    },

    getColors(primaryZine) {
      if (primaryZine) {
        return {
          background: primaryZine.backColor,
          text: this.getTextColor(primaryZine.backColor)
        };
      } else {
        return DEFAULT_COLORS;
      }
    }
  },

  ZinePending: {
    mixins: [createStoreMixin(ZinePendingStampStore, ZineStore, StampStore), BackColorMixin],

    getZineSlug: function () {
      return this.props.params.zineSlug;
    },

    isExpectingPage() {
      var zineSlug = this.getZineSlug();
      return ZinePendingStampStore.isExpectingPage(zineSlug);
    },

    isLastPage() {
      var zineSlug = this.getZineSlug();
      return ZinePendingStampStore.isLastPage(zineSlug);
    },

    requestPage: function (isInitialRequest) {
      var zineSlug = this.getZineSlug();
      StampActionCreators.requestZinePendingPage(zineSlug, isInitialRequest);
    },

    getPage: function () {
      var zineSlug = this.getZineSlug();
      return ZinePendingStampStore.getStamps(zineSlug);
    },

    getStampPrimaryZine(stampId) {
      return StampStore.getPrimaryZine(stampId);
    },

    getStampPendingZine(stampId) {
      var zineSlug = this.getZineSlug(),
          stamp = StampStore.get(stampId);

      if (stamp && stamp.pendingZines.indexOf(zineSlug) > -1) {
        return ZineStore.get(zineSlug);
      }
    },

    getNextUpTitle() {
      var zineSlug = this.getZineSlug(),
          zine = ZineStore.get(zineSlug);

      if (zine) {
        return `Also Submitted to ${zine.title}`;
      }
    },

    shouldShowPrimaryZineInNextUp() {
      return true;
    },

    getColors(primaryZine) {
      if (primaryZine) {
        return {
          background: primaryZine.backColor,
          text: this.getTextColor(primaryZine.backColor)
        };
      } else {
        return DEFAULT_COLORS;
      }
    }
  }
};



/** WEBPACK FOOTER **
 ** ./mixins/StampPageMixins.js
 **/